import {createTheme, CssBaseline, ThemeProvider} from '@mui/material';
import {useSelector} from 'react-redux';
import {getDesignTokens} from './theme';
import {ReactNode} from 'react';
import { selectCurrentTheme } from '../selectors/common';

interface ThemeWrapperProps {
  children: ReactNode;
}

const ThemeWrapper: React.FC<ThemeWrapperProps> = ({ children }) => {
  const darkTheme = useSelector(selectCurrentTheme);
  const theme = createTheme(getDesignTokens(darkTheme ? 'dark' : 'light') as any)
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default ThemeWrapper;